const mitraPaymentDomainApiUrl = process.env.MITRA_PAYMENT_DOMAIN_API_URL;

export default mitraPaymentDomainApiUrl;
